// Reserved for minimal logic that triggers "above the fold"

function setGlobalVariables() {
  window.config = window.config || {}

  const isTouchCapable = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (isTouchCapable) {
    document.documentElement.classList.add('is-touch');
  } else {
    document.documentElement.classList.add('no-touch');
  }

  document.body.style.setProperty('--initial-height', `${window.innerHeight}px`)

  window.addEventListener('resize', updateGlobalVariables)
  updateGlobalVariables()
}

function updateGlobalVariables() {
  // Used for things like popups, drawers, etc. that need to be constrained within the viewable portion of a scroll-locked window
  document.body.style.setProperty('--inner-height', `${window.innerHeight}px`)

  setHeight({ selector: '.section-header', variable: 'navHeight', property: '--nav-height' })
  setHeight({ selector: '.announcement-bar', variable: 'barHeight', property: '--bar-height' })
}

function setHeight({ selector, variable, property }) {
  const elements = document.querySelectorAll(selector)

  elements.forEach(element => {
    if (element.checkVisibility()) {
      window.config[variable] = element.clientHeight
    }
  })

  document.documentElement.style.setProperty(property, `${window.config[variable]}px`)
}

setGlobalVariables()